export default {
  selector: '[data-comp-favorite-count]',
  textSelector: '[data-comp-favorite-count-text]',
};
